import React, { useEffect, useState } from 'react'
import InputLabel from 'components/Form/InputLabel'
import { newsletterSignupApi } from 'apis/newsletter'
import useFormData from 'hooks/formData'
import debounce from 'lib/debounce'
import { formValidationRulesNewsletter } from './helpers'
import { REQUEST_SOURCE } from '../../../../../server/constants/newsletter_request_sources'
const emailDebounce = debounce()

const Component = (): React.ReactElement<React.ComponentProps<any>, any> | null => {
  const [newsletterConfirmation, handleNewsletterConfirmation] = useState(false)
  const { formData, formErrors, onChangeInput, validateFormData } = useFormData({
    initialState: {
      email: '',
    },
    formRules: formValidationRulesNewsletter,
  })
  const { email } = formData
  const { email: emailError } = formErrors
  useEffect(() => {
    if (email) {
      emailDebounce(async () => {
        await validateFormData()
      })
    }
  }, [formData, email])

  const onSubmit = async (): void => {
    const params = {
      email,
      requestSource: REQUEST_SOURCE.TRADE_PAGE,
      sourceURL: window.location.href,
    }
    await newsletterSignupApi(params)
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'newsletter signup success',
        email_signup_source: REQUEST_SOURCE.TRADE_PAGE,
      })
      window.dataLayer.push({
        event: 'complete trade newsletter signup',
        label: 'complete',
      })
    }
    handleNewsletterConfirmation(true)
  }

  if (newsletterConfirmation) {
    return <p data-type='confirmNewsletter'>Thank you! You're now subscribed to our list.</p>
  }

  return (
    <form
      onSubmit={(ev) => {
        ev.preventDefault()
      }}
    >
      <InputLabel
        error={emailError}
        id='email'
        maxLength='60'
        name='email'
        onChange={onChangeInput}
        placeholder='Email Address'
        type='text'
        value={email}
      />

      <button
        type='button'
        onClick={onSubmit}
        {...(emailError
          ? {
              disabled: 'disabled',
            }
          : {})}
      >
        Subscribe
      </button>
    </form>
  )
}

export default Component
